<div fxLayoutAlign="space-between center" fxLayoutGap="0.625rem">
  <div fxFlex="1 1 auto">
    @if (data.message) {
      <p class="message">{{ data.message }}</p>
    }
    @if (data.html) {
      <div class="html-container" [innerHTML]="getSafeHtml()"></div>
    }
    @if (data.action) {
      <button class="action-button" mat-button (click)="actionBtnClicked()">
        {{ data.action }}
      </button>
    }
  </div>

  <div fxFlex="0 0 auto">
    <button mat-icon-button (click)="closeSnackBar()" aria-label="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
